import api from "./api";

export default class POSApi {
  static postPOS = async (obj: any) => {
    const response = await api.post(`/POS`, obj);
    return response.data;
  };

  static getPOSList = async (
    Page: number,
    RecordsPerPage: number,
    search: string,
    idCliente: number
  ) => {
    const response = await api.get(
      `/POS?Page=${Page}&RecordsPerPage=${RecordsPerPage}&Search=${search}&idCliente=${idCliente}`
    );
    return response;
  };

  static deletePOSById = async (id: number) => {
    const response = await api.delete(`/POS/${id}`);
    return response.data;
  };

  static updatePOS = async (id: number, obj: any) => {
    const response = await api.put(`/POS/${id}`, obj);
    return response.data;
  };

  static getPOSById = async (id: number) => {
    const response = await api.get(`/POS/${id}`);
    return response.data;
  };

  static getChipsByPOSId = async (id: number) => {
    const response = await api.get(`/PosChip/chips/pos/${id}`);
    return response;
  };

  static updatePosChips = async (id: number, obj: any) => {
    const response = await api.put(`/PosChip/${id}`, obj);
    return response.data;
  };

  static getPosChipById = async (id: number) => {
    const response = await api.get(`/PosChip/chips/pos/${id}`);
    return response.data;
  };

}
